import cidrRegex from 'cidr-regex';
import { z } from 'zod';
import {
  DEFAULT_NETMASK_REQUIRED_v4_LOCAL_ERR,
  DEFAULT_NETMASK_REQUIRED_v6_LOCAL_ERR,
  EMPTY_ERR,
  filterInterface,
  filterIpV4,
  filterIpV6,
  MIXED_LOCAL_INTERFACE_ERR,
  validAllowDeny,
} from './helpers/allow-list.ts';

const localAllowCIDRRuleSchema = z.object({
  allow: z.boolean(),
  cidr: z.string({ required_error: EMPTY_ERR }).regex(cidrRegex({ exact: true })), // the real validation happens outside of zod
});
const localAllowInterfaceRuleSchema = z.object({
  allow: z.boolean(),
  interface: z.string().min(1, EMPTY_ERR), // the real validation happens outside of zod
});

const localAllowRuleSchema = z.union([localAllowCIDRRuleSchema, localAllowInterfaceRuleSchema]);

// Aligns with the actual ConfigOverride type:
//   {[cidr: string]: boolean | Record<string, boolean>, interfaces: {[iface: string]: boolean}}
export const localAllowRuleOverrideSchema = z
  .object({ interfaces: z.record(z.string(), z.boolean()).or(z.object({})) })
  .and(
    z.record(
      z.union([z.literal('interfaces'), z.string().regex(cidrRegex({ exact: true }))]),
      z.boolean().or(z.record(z.string(), z.boolean()))
    )
  );

// Note: this is used for the host page, but not tag config
export const localAllowListSchema = z
  .array(localAllowRuleSchema)
  .refine((values) => validAllowDeny(filterIpV4(values)), DEFAULT_NETMASK_REQUIRED_v4_LOCAL_ERR)
  .refine((values) => validAllowDeny(filterIpV6(values)), DEFAULT_NETMASK_REQUIRED_v6_LOCAL_ERR)
  .refine((values) => validAllowDeny(filterInterface(values)), MIXED_LOCAL_INTERFACE_ERR);
